module.exports = __webpack_public_path__ + "static/media/mq.80949ae9.svg";